import React from 'react'
import Slider from '@mui/material/Slider';

const marks = [
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 75, label: '75' },
    { value: 100, label: '100' },
    { value: 125, label: '125' },
    { value: 150, label: '150' },
];

const Rangepicker = ({ default: defaultValue, value, onChange }) => {
    return (
        <Slider
            aria-label="Restricted values"
            value={value || defaultValue || 25}  // 👈 controlled
            valueLabelDisplay="auto"
            step={25}
            marks={marks}
            min={25}
            max={150}
            onChange={(e, newValue) => onChange(newValue)}           // 👈 drag pe
            onChangeCommitted={(e, newValue) => onChange(newValue)}  // 👈 release pe
            sx={{
                color: '#29b6f6',
                '& .MuiSlider-thumb': {
                    backgroundColor: 'red',
                    width: 20,        
                    height: 20,
                    '&:hover, &.Mui-focusVisible': {
                        boxShadow: '0 0 0 8px rgba(255,0,0,0.2)',
                    },
                },
                '& .MuiSlider-track': {
                    height: 4,
                },
                '& .MuiSlider-rail': {
                    height: 4,
                },
                '& .MuiSlider-mark': {
                    width: 14,        
                    height: 14,
                    borderRadius: '50%',
                    backgroundColor: '#bbb',
                    transform: 'translate(-50%, -50%)',
                },
                '& .MuiSlider-markActive': {
                    backgroundColor: '#29b6f6',
                    width: 14,
                    height: 14,
                },
                '& .MuiSlider-markLabel': {
                    color: '#29b6f6',
                    fontSize: 14,
                    fontWeight: 400,
                },
                '& .MuiSlider-markLabelActive': {
                    color: '#29b6f6',
                },
            }}
        />
    )
}

export default Rangepicker;